import { StockItem } from 'search-gateway-client';

import { ContentType } from '@videoblocks/events-ts/lib/storyblocks/content/records/ContentTypeEnum';
import { DistributionType } from '@videoblocks/events-ts/lib/storyblocks/content/records/DistributionTypeEnum';
import { ShallowStockItem } from '@videoblocks/events-ts/lib/storyblocks/content/records/ShallowStockItem';

export default class ShallowStockItemFactory {
    static create(stockItem: StockItem): ShallowStockItem {
        const shallowStockItem = new ShallowStockItem();
        shallowStockItem.stockItemId = stockItem.stockblocksId;
        shallowStockItem.title = stockItem.title;
        shallowStockItem.publishedDate = Date.parse(stockItem.dateAdded) || 0;
        shallowStockItem.distributionType =
            stockItem.distributionType === 'ML' ? DistributionType.MEMBER_LIBRARY : DistributionType.REV_SHARE;
        shallowStockItem.contentType = ShallowStockItemFactory.contentType(stockItem.contentType);
        shallowStockItem.format = null;
        // @ts-expect-error todo TEAM-511 add these to generic StockblocksStockItem
        shallowStockItem.thumbnailUrl = (stockItem.thumbnailUrl as string) ?? null;
        shallowStockItem.contentId = stockItem.id;
        shallowStockItem.distributionTypeUpdatedDate = null;

        return shallowStockItem;
    }

    static contentType(contentType: string = ''): ContentType {
        const map: Record<string, ContentType> = {
            sfx: ContentType.SOUND_EFFECTS,
            'sound-effects': ContentType.SOUND_EFFECTS,
            illustration: ContentType.ILLUSTRATIONS,
            photo: ContentType.PHOTOS,
            snapshot: ContentType.SNAPSHOTS,
            template: ContentType.TEMPLATES,
            motionbackground: ContentType.MOTION_BACKGROUNDS,
            'motion-backgrounds': ContentType.MOTION_BACKGROUNDS,
            vector: ContentType.VECTORS,
            vr360: ContentType.VR_360,
            music: ContentType.MUSIC,
        };

        if (contentType in map) {
            return map[contentType];
        }

        throw new Error('Invalid content type for ShallowStockItem - ' + contentType);
    }
}
